var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReportIconInactive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.37215 4.94531H6.51526C6.01601 4.94531 5.5372 5.1387 5.18417 5.48293C4.83114 5.82715 4.63281 6.29403 4.63281 6.78084L4.63281 17.1759C4.63281 17.6627 4.83114 18.1296 5.18417 18.4738C5.5372 18.818 6.01601 19.0114 6.51526 19.0114H9.8263M15.7588 10.4519V6.78084C15.7588 6.29403 15.5605 5.82715 15.2075 5.48293C14.8545 5.1387 14.3756 4.94531 13.8764 4.94531H13.0195",
    stroke: "#585858",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5859 15.1328V17.0506H17.5037",
    stroke: "#585858",
    strokeWidth: 1.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1651 19.47C12.4766 18.7815 12.0898 17.8478 12.0898 16.8742C12.0898 15.9006 12.4766 14.9668 13.1651 14.2784C13.8535 13.5899 14.7873 13.2031 15.7609 13.2031C16.7345 13.2031 17.6683 13.5899 18.3567 14.2784C19.0452 14.9668 19.4319 15.9006 19.4319 16.8742C19.4319 17.8478 19.0452 18.7815 18.3567 19.47C17.6683 20.1585 16.7345 20.5452 15.7609 20.5452C14.7873 20.5452 13.8535 20.1585 13.1651 19.47Z",
    stroke: "#585858",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.66553 9.39062L12.456 9.39063",
    stroke: "#585858",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.66553 12.1094H10.9591",
    stroke: "#585858",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.66553 14.8281H9.93353",
    stroke: "#585858",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.9244 3.89018C7.57138 4.17002 7.37305 4.54956 7.37305 4.94531C7.37305 5.34107 7.57138 5.72061 7.9244 6.00045C8.27743 6.28029 8.75624 6.4375 9.2555 6.4375H11.1379C11.6372 6.4375 12.116 6.28029 12.469 6.00045C12.8221 5.72061 13.0204 5.34107 13.0204 4.94531C13.0204 4.54956 12.8221 4.17002 12.469 3.89018C12.116 3.61034 11.6372 3.45312 11.1379 3.45312H9.2555C8.75624 3.45312 8.27743 3.61034 7.9244 3.89018Z",
    stroke: "#585858",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportIconInactive);
export default __webpack_public_path__ + "static/media/report-icon-inactive.f4d2c90d30d93d9399013d2c7b606071.svg";
export { ForwardRef as ReactComponent };